import axios from "axios";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {backendBaseURL} from '../AppConstants';
const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [fetchexporterNamesList, setexporterNamesList] = useState([]);
  const [fetchimporterNamesList, setimporterNamesList] = useState([]);
  const [fetchclearingAgentNamesList, setclearingAgentNamesList] = useState([]);
  const [fetchbankNamesList, setbankNamesList] = useState([]);
  const [fetchitemNamesssList, setitemNamesList] = useState([]);
  const [fetchfinancerNamesList, setfinancerNamesList] = useState([]);
  const [fetchshippingLinesList, setshippingLinesList] = useState([]);
  const [fetchtransporterNamesList, settransporterNamesList] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [shippingDetailsData, setShippingDetailsData] = useState([]);
  const [fetchfinanceGenerationNamesList, setfinanceGenerationNamesList] = useState([]);
  const [fetchrePaymentList, setrePaymentList] = useState([]);
     //console.log("fetchexporterNamesList", fetchexporterNamesList);
  //   console.log("importerNamesList", fetchimporterNamesList);
  //   console.log("clearingAgentNamesList", fetchclearingAgentNamesList);
  //   console.log("bankNamesList", fetchbankNamesList);
  //   console.log("itemNamesssList", fetchitemNamesList);
  //   console.log("financerNamesList", fetchfinancerNamesList);

  const fetchData = useCallback(() => {
    const apiUrl1 = `${backendBaseURL}/getExporterDetails`;
    const apiUrl2 = `${backendBaseURL}/getImporterDetails`;
    const apiUrl3 = `${backendBaseURL}/getClearingAgentDetails`;
    const apiUrl4 = `${backendBaseURL}/getBankDetails`;
    const apiUrl5 = `${backendBaseURL}/getItemNameDetails`;
    const apiUrl6 = `${backendBaseURL}/getFinancerDetails`;
    const apiUrl7 = `${backendBaseURL}/getSalesContractDetails`;
    const apiUrl8 = `${backendBaseURL}/getShippingDetails`;
    const apiUrl9 = `${backendBaseURL}/getShippingLineDetails`;
    const apiUrl10 = `${backendBaseURL}/getTransporterNameDetails`;
    const apiUrl11 = `${backendBaseURL}/getFinanceGenerationDetails`;
    const apiUrl12 = `${backendBaseURL}/getrePaymentDetails`;
    axios
      .all([
        axios.get(apiUrl1),
        axios.get(apiUrl2),
        axios.get(apiUrl3),
        axios.get(apiUrl4),
        axios.get(apiUrl5),
        axios.get(apiUrl6),
        axios.get(apiUrl7),
        axios.get(apiUrl8),
        axios.get(apiUrl9),
        axios.get(apiUrl10),
        axios.get(apiUrl11),
        axios.get(apiUrl12),
      ])
      .then(
        axios.spread(
          (
            response1,
            response2,
            response3,
            response4,
            response5,
            response6,
            response7,
            response8,
            response9,
            response10,
            response11,
            response12,
          ) => {
            setexporterNamesList(response1.data);
            setimporterNamesList(response2.data);
            setclearingAgentNamesList(response3.data);
            setbankNamesList(response4.data);
            setitemNamesList(response5.data);
            setfinancerNamesList(response6.data);
            setPaginationData(response7.data);
            setShippingDetailsData(response8.data);
            setshippingLinesList(response9.data);
            settransporterNamesList(response10.data);
            setfinanceGenerationNamesList(response11.data);
            setrePaymentList(response12.data);
          }
        )
      )
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   const interval = setInterval(fetchData, 4000);

  //   return () => clearInterval(interval);
  // }, [fetchData]);

  const exporterNamesList = Array.from(
    new Set(fetchexporterNamesList.map((data) => data.exporterName))
  );
  const importerFirmNamesList = Array.from(
    new Set(fetchimporterNamesList.map((data) => data.importerName))
  );
  const itemNamesList = Array.from(
    new Set(fetchitemNamesssList.map((data) => data.itemName))
  );
  const bankNamesList = Array.from(
    new Set(fetchbankNamesList.map((data) => data.bankName))
  );
  const financerNamesList = Array.from(
    new Set(fetchfinancerNamesList.map((data) => data.financerOrganizationName))
  );
  const clearingAgentsList = Array.from(
    new Set(fetchclearingAgentNamesList.map((data) => data.agentCompanyName))
  );
  const shippingLinesList = Array.from(
    new Set(fetchshippingLinesList.map((data) => data.shippingName))
  );
  const transporterNamesList = Array.from(
    new Set(fetchtransporterNamesList.map((data) => data.transporterName))
  );

  const salesContractNumberList = Array.from(
    new Set(paginationData.map((data) => data.salesContractNumber))
  );

  const value = {
    fetchexporterNamesList,
    fetchimporterNamesList,
    fetchclearingAgentNamesList,
    fetchbankNamesList,
    fetchitemNamesssList,
    fetchfinancerNamesList,
    fetchfinanceGenerationNamesList,
    fetchrePaymentList,
    fetchshippingLinesList,
    fetchtransporterNamesList,
    exporterNamesList,
    importerFirmNamesList,
    itemNamesList,
    bankNamesList,
    financerNamesList,
    clearingAgentsList,
    shippingLinesList,
    transporterNamesList,
    paginationData,
    salesContractNumberList,
    shippingDetailsData
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
